import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { PaginationHeading } from '../PaginationHeading/PaginationHeading';
import { withPaginationProviderWrapper } from './PaginationStore/PaginationProvider';
import { IPaginationProps } from './BasePaginationContainer.types';

const PaginationContainer = styled.div`
  width: 100%;
`;

const Paginate: FunctionComponent<IPaginationProps> = props => {
  const { children, headingText, itemsName, showAll, onClickShowAll } = props;

  return (
    // default the container to not be tabable
    <PaginationContainer tabIndex={-1}>
      <PaginationHeading headingText={headingText} showAll={showAll} onClickShowAll={onClickShowAll} itemsName={itemsName} />
      {children}
    </PaginationContainer>
  );
};

export const BasePaginationContainer: FunctionComponent<IPaginationProps> = withPaginationProviderWrapper(Paginate);
